import { isUndefined, forEach } from 'min-dash'

import { getBusinessObject } from 'bpmn-js/lib/util/ModelUtil'

import { TextFieldEntry, isTextFieldEntryEdited, SelectEntry, isSelectEntryEdited } from '@bpmn-io/properties-panel'

import { FormTypeProps } from './utils/FormTypeProps'

import { useService } from 'bpmn-js-properties-panel'

import { getFormType, getFormRefBinding, isFormSupported } from './utils/FormTypeUtils'

import { useEffect, useState } from '@bpmn-io/properties-panel/preact/hooks'

import { getKeyMetadata } from './utils/getKeyMetada'

const EMPTY_OPTION = ''

export function FormProps(props) {
  const { element } = props

  if (!isFormSupported(element)) {
    return []
  }

  const formType = getFormType(element),
    bindingType = getFormRefBinding(element)

  // (1) display form type select
  const entries = [...FormTypeProps({ element })]

  // (2) display form properties based on type
  if (formType === 'formKey') {
    entries.push({
      id: 'formKey',
      component: FormKey,
      isEdited: isTextFieldEntryEdited,
    })
  } else if (formType === 'formRef') {
    entries.push(
      //   {
      //     id: 'formRef',
      //     component: FormRef,
      //     isEdited: isTextFieldEntryEdited,
      //   },
      {
        id: 'formRef',
        component: SistemivFormRef,
        isEdited: isSelectEntryEdited,
      },
      {
        id: 'formRefBinding',
        component: Binding,
        isEdited: isSelectEntryEdited,
      },
    )

    if (bindingType === 'version') {
      entries.push({
        id: 'formRefVersion',
        component: Version,
        isEdited: isTextFieldEntryEdited,
      })
    }
  }

  return entries
}

function FormKey(props) {
  const { element } = props

  const debounce = useService('debounceInput')
  const modeling = useService('modeling')
  const translate = useService('translate')

  const businessObject = getBusinessObject(element)

  const getValue = () => {
    return businessObject.get('camunda:formKey')
  }

  const setValue = (value) => {
    modeling.updateProperties(element, {
      'camunda:formKey': isUndefined(value) ? '' : value,
    })
  }

  return TextFieldEntry({
    element,
    id: 'formKey',
    label: translate('Form key'),
    getValue,
    setValue,
    debounce,
  })
}
// eslint-disable-next-line
function FormRef(props) {
  const { element } = props

  const debounce = useService('debounceInput')
  const modeling = useService('modeling')
  const translate = useService('translate')

  const businessObject = getBusinessObject(element)

  const getValue = () => {
    return businessObject.get('camunda:formRef')
  }

  const setValue = (value) => {
    modeling.updateProperties(element, {
      'camunda:formRef': isUndefined(value) ? '' : value,
    })
  }

  return TextFieldEntry({
    element,
    id: 'formRef',
    label: translate('Form reference'),
    getValue,
    setValue,
    debounce,
  })
}

function Binding(props) {
  const { element } = props

  const modeling = useService('modeling')
  const translate = useService('translate')

  const getValue = () => {
    return getFormRefBinding(element)
  }

  const setValue = (value) => {
    modeling.updateProperties(element, {
      'camunda:formRefBinding': value,
    })
  }

  // Note: default is "latest",
  // cf. https://docs.camunda.org/manual/develop/reference/bpmn20/custom-extensions/extension-attributes/#formrefbinding
  const getOptions = () => {
    const options = [
      { value: 'deployment', label: translate('deployment') },
      { value: 'latest', label: translate('latest') },
      { value: 'version', label: translate('version') },
    ]

    return options
  }

  return SelectEntry({
    element,
    id: 'formRefBinding',
    label: translate('Binding'),
    getValue,
    setValue,
    getOptions,
  })
}

function Version(props) {
  const { element } = props

  const debounce = useService('debounceInput')
  const modeling = useService('modeling')
  const translate = useService('translate')

  const businessObject = getBusinessObject(element)

  const getValue = () => {
    return businessObject.get('camunda:formRefVersion')
  }

  const setValue = (value) => {
    modeling.updateProperties(element, {
      'camunda:formRefVersion': value,
    })
  }

  return TextFieldEntry({
    element,
    id: 'formRefVersion',
    label: translate('Version'),
    getValue,
    setValue,
    debounce,
  })
}

// SAMO OVAJ KOD JE CUSTOM SVE OSTALO JE COPY PASTE (manje vise)
function SistemivFormRef(props) {
  const { element } = props

  const modeling = useService('modeling')
  const translate = useService('translate')

  const businessObject = getBusinessObject(element)

  const [fetchedOptions, setFetchedOptions] = useState([])

  useEffect(() => {
    getKeyMetadata('formId')
      .then(setFetchedOptions)
      .catch((e) => console.log('get key metadata formId error', e))
  }, [])

  const getValue = () => {
    return businessObject.get('camunda:formRef') ?? EMPTY_OPTION
  }

  const setValue = (value) => {
    modeling.updateProperties(element, {
      'camunda:formRef': isUndefined(value) ? EMPTY_OPTION : value,
    })
  }

  const getOptions = (element) => {
    const options = [{ value: EMPTY_OPTION, label: '<none>' }]

    forEach(fetchedOptions, (form) => {
      options.push({ value: form, label: form })
    })

    const existingValue = getBusinessObject(element)?.get('camunda:formRef')

    if (existingValue && !options.find((o) => o.value === existingValue)) {
      options.unshift({ value: existingValue, label: existingValue })
    }

    return options
  }

  return SelectEntry({
    element,
    id: 'formRef',
    label: translate('Form reference'),
    getValue,
    setValue,
    getOptions,
  })
}
